import { useEffect, useState } from 'react';

import { useTrialDetails } from './useTrialDetails.tsx';

type UsePTOModalVisibilityOnReverseTrialProps = {
	isPTORTEnabled?: boolean;
	isSiteAdmin?: boolean;
};

const COMMERCE_BACKEND_CCP = 'CCP';
const COMMERCE_BACKEND_HAMS = 'HAMS';

/**
 * Trial length for RT instance with CCP is 30 days and with HAMS is 7 days
 */
const TRIAL_DAYS = {
	[COMMERCE_BACKEND_CCP]: 30,
	[COMMERCE_BACKEND_HAMS]: 7,
	DEFAULT: 14,
};

export const usePTOModalVisibilityOnReverseTrial = ({
	isPTORTEnabled = false,
	isSiteAdmin = false,
}: UsePTOModalVisibilityOnReverseTrialProps) => {
	const {
		trialDaysLeft,
		isInstanceInTrial,
		trialDetailsLoading,
		trialDetailsError,
		billingSourceSystem,
	} = useTrialDetails({ skip: !isPTORTEnabled });

	const [showPTORTModal, setShowPTORTModal] = useState(false);
	const [showMidTrialModal, setShowMidTrialModal] = useState(false);
	const [checkPTOModalVisibilityLoading, setCheckPTOModalVisibilityLoading] = useState(true);

	useEffect(() => {
		if (!trialDetailsLoading) {
			// if we know the billing engine, we go ahead with engine defaults else, 14 days.
			const trialDays = billingSourceSystem ? TRIAL_DAYS[billingSourceSystem] : TRIAL_DAYS.DEFAULT;

			//forcing not to show any modals when instance is not in trial or trialDaysUsed cannot be determined
			const trialDaysUsed = trialDetailsError || !isInstanceInTrial ? 0 : trialDays - trialDaysLeft;

			/**
			 * Show initial modal on
			 * day 2 and onwards for HAMS and day 3 and onwards for CCP
			 * Show mid trial modal to non site admins on day 4 and onwards for HAMS and day 15 and onwards for CCP
			 */

			if (billingSourceSystem === COMMERCE_BACKEND_CCP) {
				setShowPTORTModal(trialDaysUsed >= 3);
				setShowMidTrialModal(!isSiteAdmin && trialDaysUsed >= 15);
			} else {
				setShowPTORTModal(trialDaysUsed >= 2);
				setShowMidTrialModal(!isSiteAdmin && trialDaysUsed >= 4);
			}
			setCheckPTOModalVisibilityLoading(false);
		}
	}, [
		billingSourceSystem,
		isInstanceInTrial,
		isSiteAdmin,
		setShowMidTrialModal,
		setShowPTORTModal,
		trialDaysLeft,
		trialDetailsError,
		trialDetailsLoading,
	]);

	return {
		showPTORTModal,
		showMidTrialModal,
		loading: trialDetailsLoading || checkPTOModalVisibilityLoading,
	};
};
